import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { ROUTES } from '../../../shared/constants/app.constant';
import { authKeys } from '../constants/auth.constant';
import type { CallbackStatus } from '../models/auth.model';
import { authService } from '../services/auth.service';

export interface AuthCallbackState {
  readonly status: CallbackStatus;
  readonly errorMessage: string | null;
}

export function useAuthCallback(): AuthCallbackState {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const token = params.get('token');
  const started = useRef(false);

  const mutation = useMutation({
    mutationFn: authService.exchange,
    onSuccess: (data) => {
      queryClient.setQueryData(authKeys.me, data);
      void navigate(ROUTES.dashboard, { replace: true });
    },
  });
  const { mutate } = mutation;

  // Token sekali pakai: StrictMode menjalankan effect dua kali di dev, ref mencegah penukaran ganda.
  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    window.history.replaceState(null, '', ROUTES.authCallback);
    mutate(token);
  }, [token, mutate]);

  if (!token) return { status: 'missing-token', errorMessage: null };
  if (mutation.isError) return { status: 'failed', errorMessage: mutation.error.message };
  return { status: 'exchanging', errorMessage: null };
}
